import React from 'react';

import { useForm, Controller, FieldValues } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import dynamic from 'next/dynamic';

import { ErrorViewModel } from '@api/index';
import { FlexibleDiv, Separator } from '@components/formStyles';
import { Field } from '@components/utils/form';
import ErrorMessages from '@components/ui/errors/ErrorMessages';
import Email from '@components/ui/form/Email';
import { logFormErrors } from '@utils/gtm/error-log-gtm';

import { Label, StyledButton } from '../styled';
import { SeturFormSchema } from '../../validation/schemas';
const GeneralLoader = dynamic(() => import('@components/ui/GeneralLoader'));
interface SeturFormProps {
  onSubmitEmail: (formData: SeturLoginData) => void;
  errorMessages?: ErrorViewModel[];
  isPostLoginLoading?: boolean;
  isSuccess?: boolean;
}

export interface SeturLoginData {
  seturEmail: string;
}

const initialValues = {
  seturEmail: '',
};

const SeturForm = ({
  onSubmitEmail,
  errorMessages,
  isPostLoginLoading,
  isSuccess,
}: SeturFormProps) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm<SeturLoginData>({
    defaultValues: initialValues,
    resolver: yupResolver(SeturFormSchema),
  });
  const onError = (errors: FieldValues) => {
    if (errors) {
      const fieldNames = Object.keys(errors).join(', ');
      logFormErrors('LoginForm', fieldNames);
    }
  };
  return (
    <>
      <FlexibleDiv bottom={20}>
        <Label center bold fontSize={24}>
          Giriş Yap
        </Label>
      </FlexibleDiv>

      <form onSubmit={handleSubmit(onSubmitEmail, onError)}>
        <Controller
          control={control}
          name='seturEmail'
          render={({ field }) => (
            <Field
              Component={Email}
              errorMessage={errors.seturEmail?.message}
              errorPropName='error'
              hasError={
                Boolean(errors.seturEmail?.message) ||
                Boolean(errorMessages?.length)
              }
              label='E-posta'
              {...field}
            />
          )}
        />
        <Separator />

        {errorMessages?.length ? (
          <ErrorMessages errors={errorMessages} />
        ) : null}

        <StyledButton
          loading={isSubmitting}
          disabled={isSubmitting}
          type='submit'
          variant='Primary'
        >
          Giriş Yap
        </StyledButton>
      </form>
      {isPostLoginLoading || isSuccess ? <GeneralLoader /> : null}
    </>
  );
};

export default SeturForm;
